module.exports = __webpack_public_path__ + "img/i_block_off.aab9fc75.svg";